const ikonLista = {
  type_plastic: 'icons-plastic-26.png',
  type_dangerous: 'fa-biohazard',
  type_metal: 'fa-tools',
  type_automotive: 'fa-car-crash',
  type_construction: 'fa-house-damage',
  type_deadAnimals: 'fa-dog',
  type_domestic: 'fa-drumstick-bite',
  type_electronic: 'fa-plug',
  type_glass: 'fa-wine-glass-alt',
  type_liquid: 'fa-tint',
  type_organic: 'fa-leaf',
  size_bag: 'zsak.svg',
  size_wheelbarrow: 'talicska.svg',
  size_car: 'teherauto.svg',
  Default: 'fa-question',
};

export const getIkonByNev = function(nev) {
  return ikonLista[nev] || ikonLista['Default'];
};
